import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
}

const CHAVE_LS = 'cardapio-sischef:auth';

function carregar(): AuthState {
  if (typeof localStorage === 'undefined') return { accessToken: null, refreshToken: null };
  try {
    const raw = localStorage.getItem(CHAVE_LS);
    if (!raw) return { accessToken: null, refreshToken: null };
    return JSON.parse(raw) as AuthState;
  } catch {
    return { accessToken: null, refreshToken: null };
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: carregar(),
  reducers: {
    definirTokens(state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem(CHAVE_LS, JSON.stringify(state));
    },
    limparTokens(state) {
      state.accessToken = null;
      state.refreshToken = null;
      localStorage.removeItem(CHAVE_LS);
    },
  },
});

export const { definirTokens, limparTokens } = authSlice.actions;
export const authReducer = authSlice.reducer;
